export var HashType = function (HashType) {
  HashType["SHA256"] = "SHA-256";
  HashType["SHA384"] = "SHA-384";
  HashType["SHA512"] = "SHA-512";
  return HashType;
}({});